import Lookup from 'src/componentes/select-async';
import ParametroEdit from 'src/paginas/matriz-orcamentaria/parametro-entidade/edit';
import ParametroList from 'src/paginas/matriz-orcamentaria/parametro-entidade/view';

const ParametroLookup = (props) => (
  <Lookup
    valueComponent={props.renderParametroEntidade}
    valueKey="id"
    labelKey="nome"
    showSearch
    clearable={true}
    url="/ParametroEntidadeLookup"
    editComponent={ParametroEdit}
    searchComponent={ParametroList}
    {...props}
  />
);

export default ParametroLookup;
